import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Header, Footer, MainContainer, GameDetails, GamesContainer, AboutContainer, FaqContainer, PrivacyContainer, TermsContainer, CookiesContainer } from './components';

const App = () => {
  return (
    <AnimatePresence mode="wait">
      <div className="flex flex-col min-h-screen bg-gray-950">
        <Header />
        <main className="flex-grow mt-20 w-full">
          <Routes>
            <Route path="/" element={<MainContainer />} />
            <Route path="/games" element={<GamesContainer />} />
            <Route path="/about" element={<AboutContainer />} />
            <Route path="/:slug" element={<GameDetails />} />
            <Route path="/faq" element={<FaqContainer />} />
            <Route path="/privacy" element={<PrivacyContainer />} />
            <Route path="/terms" element={<TermsContainer />} />
            <Route path="/cookies" element={<CookiesContainer />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </AnimatePresence>
  );
};

export default App;